import { Component, OnDestroy } from '@angular/core';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { Subject, takeUntil } from 'rxjs';

import { IConfirmAndNotifyDialogData, NotificationCallback } from 'editing-tool/src/app/shared/components/confirm-and-notify-dialog/confirm-and-notify-dialog-data';

@Component({
    templateUrl: './confirm-and-notify-dialog.component.html',
    standalone: false
})
export class ConfirmAndNotifyDialogComponent implements OnDestroy {

    public dialogData: IConfirmAndNotifyDialogData;

    public requestInProcess: boolean;

    private readonly _destroy$ = new Subject<void>();

    constructor(dialogConfig: DynamicDialogConfig, private readonly _dialogRef: DynamicDialogRef) {
        this.dialogData = dialogConfig.data;
    }

    public ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }

    public sendStandardNotification(): void {
        this._executeNotification(this.dialogData.standardNotification);
    }

    public sendCustomNotification(): void {
        this._executeNotification(this.dialogData.customNotification);
    }

    public doNotNotify(): void {
        this._executeNotification(this.dialogData.noNotification);
    }

    private _executeNotification<T>(notification: NotificationCallback<T>): void {

        this.requestInProcess = true;

        notification.action$
            .pipe(takeUntil(this._destroy$))
            .subscribe(r => {
                this.requestInProcess = false;

                notification.callback(r);

                this._dialogRef.close(true);
            });
    }
}
